import React from "react";
import { Navigate } from "react-router-dom";


//login
import Login from "../pages/Authentication/Login";

import Logout from "../pages/Authentication/Logout";



//Charts



//Job pages


// Landing Index




// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import Caisse from "../pages/Caisse/Caisse";


const authProtectedRoutes = [



    //User Profile
    { path: "/profile", component: <UserProfile /> },
    { path: "/caisse", component: <Caisse /> },

    { path: "/logout", component: <Logout /> },

    {
        path: "/",
        exact: true,
        component: <Navigate to="/caisse" />,
    },
    { path: "*", component: <Navigate to="/caisse" /> },
];

const publicRoutes: any = [

    {
        path: "/",
        exact: true,
        component: <Navigate to="/login" />,
    },
    { path: "*", component: <Navigate to="/login" /> },
    // Authentication Page   
    { path: "/login", component: <Login /> },


];

export { authProtectedRoutes, publicRoutes };